import { MODEL_CATALOG_API_URL } from '../api/config';

export const MODEL_CATALOG_VALIDATION_ERRORS = {
  NEED_ENDPOINT: 'need_endpoint',
  INVALID_ENDPOINT: 'invalid_endpoint',
  NEED_REAL_HOST: 'need_real_host'
};

export function validateModelCatalogEndpoint(endpoint) {
  const normalizedEndpoint = String(endpoint || '').trim();

  if (!normalizedEndpoint) {
    return {
      ok: false,
      code: MODEL_CATALOG_VALIDATION_ERRORS.NEED_ENDPOINT
    };
  }

  let endpointUrl;
  try {
    endpointUrl = new URL(normalizedEndpoint);
  } catch (e) {
    endpointUrl = null;
  }

  if (!endpointUrl) {
    return {
      ok: false,
      code: MODEL_CATALOG_VALIDATION_ERRORS.INVALID_ENDPOINT
    };
  }

  if (endpointUrl.hostname.toLowerCase() === 'host') {
    return {
      ok: false,
      code: MODEL_CATALOG_VALIDATION_ERRORS.NEED_REAL_HOST
    };
  }

  return {
    ok: true,
    endpoint: normalizedEndpoint
  };
}

export async function requestModelCatalog({ provider = '', type = 'text', endpoint = '', apiKey = '' }) {
  const response = await fetch(MODEL_CATALOG_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      provider,
      type,
      endpoint,
      apiKey
    })
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok || result.code !== 0) {
    const error = new Error(result.message || '');
    error.status = response.status;
    error.resultCode = result.code;
    throw error;
  }

  return {
    models: Array.isArray(result.data) ? result.data : [],
    sourceHost: result.sourceHost || ''
  };
}
